<template>
	<div class="flex flex-col gap-3">
		<form-validation-errors :errors="errors"></form-validation-errors>
		<form-select :items="options" placeholder="Action *" @valueChange="form.status_id = $event" :value="form.status_id" class="col-span-2">
			<template v-slot:icon>
				<i class="fas fa-fw fa-caret-down"></i>
			</template>
		</form-select>
		<form-input v-model="form.date_at" type="datetime-local" placeholder="Date"> </form-input>
		<form-textarea :placeholder="'Commentaire'" v-model="form.comment"> </form-textarea>
		<ui-button @click="$emit('send', form)" :loading="loading">
			<template v-slot:icon>
				<i class="fas fa-circle-plus"></i>
			</template>
			<template v-slot:text>Valider</template>
		</ui-button>
	</div>
</template>

<script setup>
	import { ref, computed } from 'vue';
	import { usePage } from '@inertiajs/vue3';
	import { DateTime } from 'luxon';

	const page = usePage();

	const props = defineProps({
		loading: {
			type: Boolean,
			default: false,
		},
		errors: {
			type: Object,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['send']);

	const form = ref({
		status_id: null,
		date_at: DateTime.now().toISO().substr(0, 16),
		comment: null,
	});

	const options = computed(() => {
		return Object.values(page.props.str.statuses)
			.filter((status) => status.type === 'action')
			.map((status) => ({
				value: status.id,
				name: status.name,
			}));
	});
</script>
